import React, {useEffect, useState} from 'react';
import {FormControl, InputLabel, MenuItem, Select} from '@mui/material';
import styles from './m-dynamic-select.module.scss';

const DynamicSelect = ({options, defaultValue, onChange, label, seperatedLabel = false}) => {
    const [selectedValue, setSelectedValue] = useState(defaultValue || '');

    const handleChange = (event) => {
        const newValue = event.target.value;
        setSelectedValue(newValue);
        if (onChange) {
            onChange(newValue);
        }
    };

    useEffect(() => {
        if (defaultValue) {
            setSelectedValue(defaultValue);
        }
    }, [defaultValue]);

    return (
        <div className={styles.dynamicSelect}>
            {seperatedLabel && <div className={styles.label}>{label}</div>}
            <FormControl fullWidth={true} size={'small'}>
                <InputLabel id="dynamic-select-label">{label}</InputLabel>
                <Select
                    labelId="dynamic-select-label"
                    id="dynamic-select"
                    variant={'outlined'}
                    value={selectedValue}
                    label={label}
                    onChange={handleChange}
                >
                    {options?.map((option) => (
                        <MenuItem value={option.value}>{option.text}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
}

export default DynamicSelect;
